module.exports = __webpack_public_path__ + "_assets/img/pTaiwan.f86d5488.svg";